export default "__VITE_ASSET__eDUcxrDi__"